import React, { useState, useEffect, useCallback } from "react";
import { Form, Button, Select, DatePicker, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import * as zoneActions from "../../../redux/actions/zone.actions";
import * as calcelledOrderActions from "../../../redux/actions/cancelledOrder.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { RangePicker } = DatePicker;
const statusOption = [
  {value: 'pending', label: 'Pending'},
  {value: 'rider_handed_to_mart', label: 'Given to mart'},
  {value: 'mart_recieved_from_rider', label: 'Received by mart'},
]

const CancelledOrderFilter = (props) => {
  const [postDataZone, setPostDataZone] = useState(null);
  const [postDataZoneIdsAll, setPostDataZoneIdsAll] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
    
  useEffect(() => {
    if (props.pageFilter){
      form.setFieldsValue(props.pageFilter || null);
    }
  }, [props.pageFilter])

  useEffect(() => {
    postLists()
  }, []);

  const postLists = useCallback(async() => {
    try {
      setLoading(true);
      await props.zoneActions.getZoneListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  }, [])
  
  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      const zoneDataAll = [];
      props.zoneData.map((item) => {
        zoneData.push({value: item?.storeId, label: item?.zoneName})
        zoneDataAll.push(item?.storeId);
      });
      setPostDataZoneIdsAll(zoneDataAll);
      setPostDataZone([ {value: 'all', label: "All"}, ...zoneData]);
    }
  }, [props.zoneData]);

  const onChangeHandelZone = async (value) => {
    // console.log("value", value)
    if(value?.includes("all")){
      // console.log("value all", value)
      form.setFieldsValue({
        ...props.pageFilter,
        storeIds: postDataZoneIdsAll,
      });
    }
  }

  const filterChange = useCallback((value) => {
    const pageData = {
      ...props.pageFilter,
      ...value,
      page: 1,
    };
    props.calcelledOrderActions.filterAction(pageData);
  },[])

  return (
    <Form form={form} className="fliters_form" disabled={loading || props?.pageLoader} onFinish={filterChange} layout="vertical" initialValues={{ modifier: 'public', }}>
      <Form.Item
       name={["storeIds"]}
       label={(<>Search Zone</>)}
       rules={[{required: true, message: 'Please select zone'}]}
      >
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={postDataZone}
          onChange={onChangeHandelZone}
          style={{ minWidth: 300,}}
        />
      </Form.Item>
      <Form.Item
       name={["date"]}
       label={"Date"}
      >
        <RangePicker
          allowClear={false}
          format="YYYY-MM-DD"
        />
      </Form.Item>
      <Form.Item
       name={["status"]}
       label={(<>Search Status</>)}
      >
        <Select
          allowClear
          showSearch
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={statusOption}
          style={{ minWidth: '140px',}}
        />
      </Form.Item>
      <Form.Item
       name={["riderId"]}
       label={(<>Search Rider ID</>)}
      >
        <Input allowClear style={{ width: '120px',}}/>
      </Form.Item>
      <Form.Item
       name={["orderId"]}
       label={(<>Search Order ID</>)}
      >
        <Input allowClear style={{ width: '120px',}}/>
      </Form.Item>
      <Button htmlType="submit" loading={loading || props?.pageLoader}>Search <SearchOutlined /></Button>
      {/* <Button onClick={()=>filterChange(null)}>Reset</Button> */}
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    pageLoader: state.CancelledOrderReducer.initialLoading,
    pageFilter: state.CancelledOrderReducer.initialFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    calcelledOrderActions: bindActionCreators(calcelledOrderActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CancelledOrderFilter);

